import { HttpError } from "@bps/http-client";

export interface RunResult {
  id: string;
  tenantName: string;
  ok: boolean;
  detail?: string;
}

const CONCURRENCY_LIMIT = 30;

const OK_RESULT = "ok";

export const isOkResult = (result: string) =>
  result.trim().toLowerCase() === OK_RESULT;

// A thrown HttpError still needs a readable message for the failed list.
export const describeError = (e: unknown): string => {
  if (HttpError.isHttpError(e)) {
    return e.message || `HTTP ${e.httpStatusCode}`;
  }
  return e instanceof Error ? e.message : "request failed";
};

export const runInBatches = async <T, R>(
  items: T[],
  worker: (item: T) => Promise<R>
): Promise<R[]> => {
  if (items.length === 0) {
    return [];
  }

  const batch = await Promise.all(
    items.slice(0, CONCURRENCY_LIMIT).map(worker)
  );

  const rest = await runInBatches(items.slice(CONCURRENCY_LIMIT), worker);
  return [...batch, ...rest];
};
